import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.color.Gray10};
  min-height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 521px;
  padding: 52px 28px 56px;
  background: ${({ theme }) => theme.color.White};
  box-shadow: 10px 10px 30px 14px rgba(0, 0, 0, 0.05);
  border-radius: 32px;

  @media (min-width: 1280px) {
    padding: 91px 95px 97px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  max-width: 384px;
  height: 54px;
  background: rgba(255, 45, 46, 1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 1);
  border: none;
  cursor: pointer;
`;
